import React from 'react';

const OtpInput = ({ length, onComplete, setOtp, otp }) => {

    const handleChange = (event) => {
        const { value } = event.target;
        setOtp(value.slice(0, length));

        if (value.length === length) {
            setOtp(value);
        }
    };

    return (
        <div className="flex justify-center items-center space-x-2">
            <div className="relative flex items-center">
                <input
                    type="password"
                    value={otp}
                    onChange={handleChange}
                    maxLength={length}
                    placeholder='XXXX'
                    className="w-64 h-12  text-xl text-center bg-inputBg rounded-lg focus:border-blue-800 focus:outline-none"
                    style={{
                        letterSpacing: '20px'
                    }}
                />
            </div>
        </div>
    );
};

export default OtpInput;
